module.exports = __webpack_public_path__ + "static/media/create-event-icon.40fb5a48.svg";